export function formatMark(value) {
  const numeric = Number(value) || 0;
  return Number.isInteger(numeric) ? String(numeric) : numeric.toFixed(2).replace(/0+$/, '').replace(/\.$/, '');
}

export function getSectionScoreSummary(questions = []) {
  const score = questions.reduce((total, question) => total + (Number(question?.score) || 0), 0);
  const maxPoints = questions.reduce((total, question) => total + (Number(question?.maxPoints) || 0), 0);
  const missedItems = questions.filter((question) => {
    const maximum = Number(question?.maxPoints) || 0;
    return maximum > 0 && (Number(question?.score) || 0) < maximum;
  }).length;

  return {
    score,
    maxPoints,
    missedItems,
    label: `${formatMark(score)}/${formatMark(maxPoints)} · ${missedItems} ${missedItems === 1 ? 'item' : 'items'} missed`,
  };
}

export function getSectionTabLabel(section = {}) {
  return String(section.title || '').trim() || 'Untitled section';
}

export function getQuestionScoreState(score, maxPoints) {
  const earned = Number(score) || 0;
  const available = Number(maxPoints) || 0;

  if (available > 0 && earned >= available) {
    return { key: 'full', label: `✓ Full marks · ${formatMark(earned)}/${formatMark(available)}` };
  }
  if (earned > 0) {
    return { key: 'partial', label: `◐ Partial · ${formatMark(earned)}/${formatMark(available)}` };
  }
  return { key: 'none', label: `× No marks · ${formatMark(earned)}/${formatMark(available)}` };
}

export function splitAcceptedAnswerLines(value) {
  const lines = String(value || '')
    .split(/\r?\n/)
    .map((line) => line.trim().replace(/^(?:[-*•]|\d+[.)])\s*/, ''))
    .filter(Boolean);

  return lines.length ? lines : ['Not provided'];
}

export function resolveSummaryFeedback(history = {}) {
  const structured = history?.summaryFeedback || {};
  const legacy = String(history?.summaryComments || '').trim();

  return {
    whatWentWell: String(structured.whatWentWell || '').trim()
      || 'Detailed strengths were not separated for this earlier attempt.',
    whatCostMarks: String(structured.whatCostMarks || '').trim()
      || 'Review the section and examiner-question feedback below for missed marks.',
    howToImprove: String(structured.howToImprove || '').trim()
      || legacy
      || 'No improvement summary was provided for this case.',
  };
}
